module.exports = __webpack_public_path__ + "img/tanq.4b3b6275.png";